import { useEffect } from 'react';
import { appNameSet, userInfo } from 'core/store/modules/common/actions';
import { useDispatch } from 'react-redux';

export const useApp = (appName: string) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(appNameSet(appName));
    dispatch(userInfo());
  }, []);
};
